module.exports = __webpack_public_path__ + "img/home-map.f8597a7d.png";